import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import { isDefined } from "@mapmycustomers/shared/util/assert";

const mergeFilterModels = (
  existingFilterModel: FilterModel,
  newFilterModel: Partial<FilterModel>
): FilterModel => {
  const resultingFilterModel: FilterModel = { ...existingFilterModel };
  Object.keys(newFilterModel).forEach((fieldName) => {
    const condition = newFilterModel[fieldName];
    // TODO: consider changing this logic to the following:
    // - when condition is undefined - ignore it
    // - when condition is null - delete such filter
    // - otherwise, update filter with a new condition
    // The reason for this update is some ambiguity when we deal with undefined values.
    // Does it mean to delete or is it just missing? If we start using null for delete,
    // then logic will be more straightforward.
    // Btw such logic is what AgGrid uses in the filter model updates.
    if (isDefined(condition)) {
      resultingFilterModel[fieldName] = condition;
    } else {
      delete resultingFilterModel[fieldName];
    }
  });
  return resultingFilterModel;
};

export default mergeFilterModels;
